module.exports = __webpack_public_path__ + "static/78b09a9456493eead86446bd2a4aed20a7a5f03c70eef2538d86c212f836671c-26b06455a82872b88836fce5099c6fb9.jpeg";